import { render, staticRenderFns } from "./VTSelbst.vue?vue&type=template&id=057808ee"
import script from "./VTSelbst.vue?vue&type=script&lang=js"
export * from "./VTSelbst.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports